import type { HgClubInfo } from '@ps/web-shared-api-types/v0/SwHomeGames';

import { UserClubRole } from '../types/common';

const filterClubs = ({ roleForUser }: HgClubInfo) =>
  roleForUser !== UserClubRole.Confirmation && roleForUser !== UserClubRole.Suspended;

export const filterOwnedClubs = ({ roleForUser }: HgClubInfo) =>
  filterClubs({ roleForUser }) &&
  (roleForUser === UserClubRole.Manager || roleForUser === UserClubRole.Admin);

export const filterJoinedClubs = ({ roleForUser }: HgClubInfo) =>
  filterClubs({ roleForUser }) &&
  (roleForUser === UserClubRole.Member ||
    roleForUser === UserClubRole.Guest ||
    roleForUser === UserClubRole.Observer);

export const filterJoinedAndOwnedClubs = ({ roleForUser }: HgClubInfo) =>
  filterClubs({ roleForUser }) &&
  (roleForUser === UserClubRole.Manager ||
    roleForUser === UserClubRole.Admin ||
    roleForUser === UserClubRole.Member ||
    roleForUser === UserClubRole.Guest ||
    roleForUser === UserClubRole.Observer);
